import { Injectable } from '@angular/core';

import { MenuController } from '@ionic/angular';
// import { Storage } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';
import { DataService } from '../services/data.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  menu_items_list: any = [];
  active_menu: any = '';
  active_sub: any = '';
  side_menu_pages: any = [];
  enable_pos_menu: any = false;
  constructor(public storage: Storage, public DBservice: DataService, private menu: MenuController) {
    if (localStorage['domain_customerId'])
      this.set_pos_menu();

    this.set_side_menu_pages();
    this.get_business_settings();
    this.get_pos_all_products();
  }

  getPaddedComp(comp:any) {
    return ((parseInt(comp) < 10) ? ('0' + comp) : comp)
  }

  get_pos_all_products() {
    if (localStorage['domain_customerId'] != undefined) {
      this.storage.get('selectmenu').then((val) => {
        if (!val || val.length == 0) {
          this.DBservice.get_all_products().subscribe((data: any) => {
            this.storage.set('selectmenu', data.message)
            var currentDate = new Date()
            // var date = aa.getFullYear() + '-' + (this.getPaddedComp(aa.getMonth() + 1)) + '-' + this.getPaddedComp(aa.getDate());
            // var month = currentDate.getMonth() + 1
            // var year = currentDate.getFullYear()
            // var day = currentDate.getDate() + 1
            localStorage['__LastSyncedDate'] = currentDate.getFullYear() + '-' + (this.getPaddedComp(currentDate.getMonth() + 1)) + '-' + this.getPaddedComp(currentDate.getDate() +1);
            // localStorage.__LastSyncedDate = new Date();
            this.DBservice.sub.next('all product');
          }, error => { console.log(JSON.stringify(error.json())); });
        }
      });
      this.storage.get('customer_list').then((val) => {
        if (!val || val.length == 0) {
          var data = {
            "page_len": 5000,
            "page_no": 1,
            "show_walk_in": 1
          }
          this.DBservice.customers_list(data)
            .subscribe((data: any) => {
              if (data.message && data.message.length > 0) {
                this.storage.set('customer_list', data.message)
              }
            }, error => {
            });
        }
      });
    }
  }

  get_business_settings() {
    if (localStorage['domain_customerId'] != undefined) {
      let me = this;
      this.DBservice.get_common_settings({ 'business': localStorage['business'], 'user': localStorage['domain_customerId'] })
        .subscribe(r => {
          if (r.message) {
            me.DBservice.common_settings = r.message;
            if (r.message.currency) {
              localStorage['currency'] = r.message.currency;
              me.DBservice.currency = r.message.currency;
            }
            if (r.message.tax_type == 'business' && r.message.tax)
              localStorage['tax_rate'] = r.message.tax;
            if (r.message.pos_register_status)
              localStorage['cash_balance'] = r.message.pos_register_status;
            if (r.message.pos_profile)
              localStorage['pos_profile'] = r.message.pos_profile;
          }
        })
    }
  }

  get_menu_list() {
    return this.menu_items_list;
  }

  set_pos_menu() {
    this.enable_pos_menu = true;
    this.menu_items_list = [
      { label: 'Dashboard', url: '/admin-dashboard', icon: 'assets/collapes-menu/dash.svg', whiteicon: 'assets/collapes-menu/dash-pur.svg', forwd_icon:'assets/collapes-menu/right-arrow.svg'},
      // { label: 'Catalog',url: undefined, icon: '/assets/collapes-menu/Category.svg',whiteicon:'/assets/collapes-menu/Category-pur.svg', forwd_icon:'/assets/collapes-menu/right-arrow.svg', sub_category:[
      //   // {label:'Category', url:'/categorylist', icon:'/assets/collapes-menu/Category.svg' ,whiteicon:'/assets/collapes-menu/Category-pur.svg', forwd_icon:'/assets/collapes-menu/right-arrow.svg'},
      //   {label:'Products', url:'/productlist', icon:'/assets/collapes-menu/Category.svg' ,whiteicon:'/assets/collapes-menu/Category-pur.svg', forwd_icon:'/assets/collapes-menu/right-arrow.svg'},
      //   // { label: 'Inventory', url: '/inventory', icon: '/assets/collapes-menu/inventory.svg', whiteicon: '/assets/collapes-menu/inventory-pur.svg', forwd_icon:'/assets/collapes-menu/right-arrow.svg' },
      // ]},
      { label: 'Products', url: '/product-list', icon: 'assets/collapes-menu/Category.svg', whiteicon: 'assets/collapes-menu/Category-pur.svg', forwd_icon:'assets/collapes-menu/right-arrow.svg' },
      { label: 'Orders', url: '/orders', icon: 'assets/collapes-menu/orders.svg', whiteicon: 'assets/collapes-menu/orders-pur.svg', forwd_icon:'assets/collapes-menu/right-arrow.svg' },
      // { label: 'Discount', url: '/discount', icon: '/assets/collapes-menu/discount.svg',whiteicon:'/assets/collapes-menu/discount-pur.svg', forwd_icon:'assets/collapes-menu/right-arrow.svg'},
      // { label: 'Customers', url: '/customers', icon: 'assets/collapes-menu/customers.svg', whiteicon: 'assets/collapes-menu/customers-pur.svg', forwd_icon:'assets/collapes-menu/right-arrow.svg' },
      // { label: 'POS', url: '/pos', icon: 'assets/collapes-menu/POS.svg', whiteicon: 'assets/collapes-menu/POS-pur.svg', forwd_icon:'assets/collapes-menu/right-arrow.svg' },
      // { label: 'Personal Details', url: '/support', icon: '/assets/collapes-menu/support.svg', whiteicon: '/assets/collapes-menu/support-pur.svg' , forwd_icon:'assets/collapes-menu/right-arrow.svg' },
      { label: 'Reports', url: '/report', icon: 'assets/collapes-menu/reports.svg', whiteicon: 'assets/collapes-menu/reports-pur.svg', forwd_icon:'assets/collapes-menu/right-arrow.svg' },
      { label: 'Support', url: '/support', icon: '/assets/collapes-menu/support.svg', whiteicon: '/assets/collapes-menu/support-pur.svg' , forwd_icon:'assets/collapes-menu/right-arrow.svg' },
      { label: 'My Profile', url: '/my-profile', icon: 'assets/collapes-menu/My-profile.svg', whiteicon: 'assets/collapes-menu/my-profile_pu.svg', forwd_icon:'assets/collapes-menu/right-arrow.svg' },
      // { label: 'Change Password', url: '/support', icon: '/assets/collapes-menu/support.svg', whiteicon: '/assets/collapes-menu/support-pur.svg' , forwd_icon:'assets/collapes-menu/right-arrow.svg' },

      // // { label: 'Category', url: '/category', icon: '/assets/Side-menu-proper/categories_white.svg',whiteicon:'/assets/Side-menu-proper/categories.svg'},
      // // { label: 'Discount', url: '/discount', icon: '/assets/Side-menu-proper/discount_white.svg',whiteicon:'/assets/Side-menu-proper/discount.svg'},
      // { label: 'Orders', url: '/orders', icon: '/assets/Side-menu-proper/orderswhite.svg', whiteicon: '/assets/Side-menu-proper/ordersvio.svg' },
      // { label: 'Customers', url: '/customers', icon: '/assets/Side-menu-proper/customers-white.svg', whiteicon: '/assets/Side-menu-proper/customers-vio-01.svg' },
      // { label: 'POS', url: '/pos', icon: '/assets/Side-menu-proper/pos-white.svg', whiteicon: '/assets/Side-menu-proper/pos-vio.svg' },
      // { label: 'Inventory', url: '/inventory', icon: '/assets/Side-menu-proper/inventory-01.svg', whiteicon: '/assets/Side-menu-proper/inventory-via.svg' },
      // { label: 'Report', url: '/report', icon: '/assets/Side-menu-proper/report-white.svg', whiteicon: '/assets/Side-menu-proper/report-violet.svg' },
    ]
  }

  set_customer_menu() {
    this.menu_items_list = [
      { label: 'Dashboard', url: '/dashboard', icon: 'home-sharp' },
      { label: 'Profile', url: '/profile', icon: 'person-sharp' },
      { label: 'Store Details', url: '/store-detail', icon: 'briefcase-sharp' },
      { label: 'Billing', url: '/billing', icon: 'pricetag-sharp' },
      { label: 'Dashboard', url: '/admin-dashboard', icon: 'pricetag-sharp' },
      { label: 'Category', url: '/category', icon: 'pricetag-sharp' },
      { label: 'Orders', url: '/orders', icon: 'pricetag-sharp' },
      { label: 'Customers', url: '/customers', icon: 'pricetag-sharp' },
      { label: 'POS', url: '/pos', icon: 'pricetag-sharp' },
      { label: 'Report', url: '/Report', icon: 'pricetag-sharp' },
    ]
  }

  set_partner_menu() {
    this.menu_items_list = [
      { label: 'Dashboard', url: '/sites', icon: 'home-sharp' },
      { label: 'Profile', url: '/profile', icon: 'person-sharp' },
      // {label: 'Store Details', url: '/store-detail', icon: 'briefcase-sharp'},
      // {label: 'Billing', url: '/billing', icon: 'pricetag-sharp'}
    ]
  }

  set_side_menu_pages() {
    this.side_menu_pages = ['/my-profile/profile-info','/my-profile/forgetten','/my-profile','/dashboard', '/profile', '/store-detail', '/billing', '/domain', '/sites', '/customer-billing', '/category', '/categorylist','product-list', '/admin-dashboard', '/orders', '/add-category', '/productlist', '/customers', '/pos', '/report', '/inventory','/discount','/addproduct','/product-attr-list', '/history','/add-discount','/web-page','/support','/profile-info','/terms'];
  }

  toggle_side_bar(url) {
    // console.log(url,"side menu enabled....")
    if (this.side_menu_pages.indexOf(url) > -1 || url.split('?')[0] == '/addproduct' || url.split('?')[0] == '/add-category' || url.split('?')[0] == '/history'|| url.split('?')[0] == '/add-discount'|| url.split('?')[0] == '/my-profile' ) {
      this.menu.enable(true, 'profileMenu');

      // this.menu_items_list.map((res) =>{
      //   // console.log(res);
      //   if(res.url == undefined){
      //     this.menu.enable(false, 'profileMenu');
      //   }
      //   else{
      //     this.menu.enable(true, 'profileMenu');
      //   } 
      // })
      let check = this.menu_items_list.find(obj => obj.url == url);
      let val;
      this.menu_items_list.map((res) =>{
        if(res.sub_category){
          val = res.sub_category;
        } 
      })
      // let value = val.find(res => res.url == url);
      // if (value) {
      //   this.active_sub = value.label
      // }
      // else{
        if(check)
          this.active_menu = check.label;
      // }
    } 
    else {
      // this.menu.enable(false, 'profileMenu');
    }
  }
} 